<template>
  <div id="app">
    <v-app>
      <v-content>
        <v-layout class="fill-viewport-height">
          <transition name="scroll">
            <router-view/>
          </transition>
        </v-layout>
      </v-content>
    </v-app>
  </div>
</template>

<script>
export default {
  name: 'App',
  mounted: {
    
  }
}
</script>

<style lang="scss">
@import 'sass/globals';
#app {
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  width: 100%;
  height: 100vh;
  font-family: Gothic, Helvetica, sans-serif;
  background-color: #40F2FF;
}

.application--wrap {
  overflow-y: auto;
  overflow-x: hidden;
}

img{
  max-width: 100%;
}

.fill-viewport-height {
    min-height: 100vh; //Antes estaba 100% pero no funcionaba en navegadores iOS
}

/********************  FONTS ********************/
/* Las fuentes se cargan acá porque se tiene acceso a los recursos que están en assets*/

@font-face {
  font-family: Helveticalstd;
  src: url('./assets/fonts/HelveticaLTStd-Light.otf');
  font-weight: normal;
}

@font-face {
  font-family: Helveticalstd;
  src: url('./assets/fonts/HelveticaLTStd-Obl.otf');
  font-style: italic;
}
@font-face {
  font-family: Helveticalstd;
  src: url('./assets/fonts/HelveticaLTStd-Bold.otf');
  font-weight: bold;
}
@font-face {
  font-family: Helveticalstd;
  src: url('./assets/fonts/HelveticaLTStd-BoldObl.otf');
  font-weight: bold;
  font-style: italic;
}
@font-face {
  font-family: helveticaNeueCn;
  src: url('./assets/fonts/HelveticaNeueLTStd-BdCn.otf');
  font-weight: bold;
}
@font-face {
  font-family: helveticaNeueCn;
  src: url('./assets/fonts/HelveticaNeueLTStd-LtCn.otf');
  font-weight: normal;
}

@font-face {
    font-family: 'MyriadPro-Cond';
    src: url('./assets/fonts/MyriadPro-Cond.eot');
    src: url('./assets/fonts/MyriadPro-Cond.eot?#iefix') format('embedded-opentype'),
        url('./assets/fonts/MyriadPro-Cond.woff2') format('woff2'),
        url('./assets/fonts/MyriadPro-Cond.woff') format('woff'),
        url('./assets/fonts/MyriadPro-Cond.ttf') format('truetype'),
        url('./assets/fonts/MyriadPro-Cond.svg#MyriadPro-Cond') format('svg');
    font-weight: normal;
    font-style: normal;
}

@font-face{
    font-family: 'MyriadPro-BoldCond';
    src: url('./assets/fonts/MyriadPro-BoldCond.eot');
    src: url('./assets/fonts/MyriadPro-BoldCond.woff2') format('woff2'),
        url('./assets/fonts/MyriadPro-BoldCond.woff') format('woff'),
        url('./assets/fonts/MyriadPro-BoldCond.ttf') format('truetype'),
        url('./assets/fonts/MyriadPro-BoldCond.svg#MyriadPro-BoldCond') format('svg'),
        url('./assets/fonts/MyriadPro-BoldCond.otf') format('opentype'),
        url('./assets/fonts/MyriadPro-BoldCond.eot?#iefix') format('embedded-opentype');
}

@font-face {
  font-family: 'Gothic';
  src: url('./assets/fonts/GOTHIC.TTF');
}
@font-face {
  font-family: 'Gothic';
  font-weight: bold;
  src: url('./assets/fonts/GOTHICB.TTF');
}
@font-face {
  font-family: 'Gothic';
  font-style: italic;
  src: url('./assets/fonts/GOTHICI.TTF');
}
@font-face {
  font-family: 'Gothic';
  font-weight: bold;
  font-style: italic;
  src: url('./assets/fonts/GOTHICBI.TTF');
}

.font-myriad{
    font-family: 'MyriadPro-BoldCond';
}

/******** IMÁGENES RETROALIMENTACIÓN BIEN Y MAL PARA DRAG N DROP **************************/
.actividad-drap-n-drop{
  .mal, .bien {
    position: relative;
    color: black;
    &:after {
      content: "";
      top: -12px;
      right: -12px;
      position: absolute;
      width: 25px;
      height: 25px;
      background-size: contain;
      z-index: 1;
    }
  }
  .mal {
    background-color: lighten(red, 30) !important;
    &:after {
      content: "";
      background-image: url("./assets/imagenes_compartidas/mal-bot.png");
    }
  }
  .bien {
    background-color: lighten($verde-cla, 20) !important;
    &:after {
      content: "";
      background-image: url("./assets/imagenes_compartidas/ok-bot.png");
    }
  }
}
/************* IMÁGENES DE BIEN/VISTO EN GENERAL *********************/

.bot-check-vis, .bot-check-vis-cen{
  position: relative;  
}

.bot-check-vis:after {
  content: " ";
  background-image: url("./assets/imagenes_compartidas/ok-bot.png");
  background-size: contain;
  position: absolute;
  width: 25px;
  height: 25px;
  top: -8px;
  right: -8px;
}

.bot-check-vis-cen:after {
  content: " ";
  background-image: url("./assets/imagenes_compartidas/ok-bot.png");
  background-size: contain;
  position: absolute;
  width: 25px;
  height: 25px;
  top: -8px;
  right: 0;
  left: 0;
  margin: auto;
}

.scroll-enter-active, .scroll-leave-active{
  transition: all 2s;
  position: absolute;
}

.scroll-enter {
  z-index: 1;
  transform: translateY(100vh);
}
.scroll-leave-to {
  transform: translateY(-90vh);
}
</style>

